export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_ENTITLEMENTS = "SET_ENTITLEMENTS";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.virtus-one.com";

export const fetchEntitlements = () => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const token = state && state.auth && state.auth.token;
            if (!token) return null;

            const response = await fetch(`${BACKEND_URL}/api/crm/provider/entitlements/`, {
                headers: {
                    "Authorization": `Token ${token}`,
                    "content-type": "application/json"
                }
            });
            if (!response.ok) return null;

            const data = await response.json();
            dispatch({ type: SET_ENTITLEMENTS, entitlements: data });
            return data;
        } catch (err) {
            // Entitlements are non-blocking; fall back to no capabilities on failure.
            return null;
        }
    };
};

export const login = (email, password) => {
    return async dispatch => {

        const response = await fetch(`${BACKEND_URL}/account/login/`, {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({ 
                email: email,
                password: password
            })
        });

        if (response.status === 200) {
            const responseData = await response.json();
            dispatch({ type: LOGIN, token: responseData.token, role: responseData.role, user: responseData.user })
            dispatch(fetchEntitlements());
            return responseData
        
        } else {
            // error handling
            const responseError = await response.json();
            throw new Error(responseError.error);
        }
    }
}

export const verifyAccount = (eid, password, role_type=null) => {
    return async dispatch => {
        // console.log(eid)
        const body = {
            eid: eid,
            newPassword: password
        };
        if (role_type) body.role_type = role_type;

        const response = await fetch("https://api.virtus-one.com/account/activateAccount/", {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(body)
        });

        if (response.status === 200) {
            const responseData = await response.json();
            // console.log(responseData)
            if (responseData.success) {
                dispatch({ type: LOGIN, token: responseData.token, role: responseData.role, user: responseData.user })
                dispatch(fetchEntitlements());
                return responseData
            } else {
                throw new Error("error");
            }
        
        } else {
            // error handling
            const responseError = await response.json();
            throw new Error(responseError.error);
        }
    }
}

export const logout = () => {
    return async (dispatch, getState) => {
        console.log('[LOGOUT] ===== LOGOUT ACTION CALLED =====');
        let sessionCleanupDone = false;
        
        try {
            console.log('[LOGOUT] Attempting to get Redux state...');
            const state = getState();
            console.log('[LOGOUT] State retrieved successfully');
            
            const token = state && state.auth && state.auth.token;
            console.log('[LOGOUT] Token check - exists:', !!token, 'type:', typeof token);
            
            if (token && token.trim()) {
                console.log('[LOGOUT] Valid token found, length:', token.length);
                const url = 'https://api.virtus-one.com/treatment/session/end-all/';
                console.log('[LOGOUT] URL:', url);
                // console.log('[LOGOUT] Authorization: Token ' + token.substring(0, 20) + '...');
                
                try {
                    console.log('[LOGOUT] About to send fetch request...');
                    const response = await fetch(url, {
                        method: 'POST',
                        headers: {
                            "Authorization": `Token ${token}`,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({})
                    });
                    console.log('[LOGOUT] Fetch completed. Status:', response.status, 'OK:', response.ok);
                    
                    if (response.ok) {
                        await response.json();
                        sessionCleanupDone = true;
                    } else {
                        const text = await response.text();
                        console.error('[LOGOUT] ✗ Endpoint returned error:', response.status, text);
                    }
                } catch (fetchErr) {
                    console.error('[LOGOUT] ✗ FETCH ERROR:', fetchErr.message, fetchErr);
                }
            } else {
                console.warn('[LOGOUT] No valid token, skipping session cleanup');
            }
        } catch (err) {
            console.error('[LOGOUT] ✗ EXCEPTION:', err.message);
            console.error('[LOGOUT] Stack:', err.stack);
        }
        
        console.log('[LOGOUT] Session cleanup result:', sessionCleanupDone ? 'SUCCESS' : 'SKIPPED/FAILED');

        try {
            const state = getState();
            const user = state && state.auth && state.auth.user;
            const userId = user && (user.id || user.user_id || user.userId || user.uuid);

            if (userId) {
                // Known per-user keys to remove
                const keysToRemove = [
                    `vp_patientMetrics_${userId}`,
                    `vp_patientScores_${userId}`,
                    `vp_selectedPatientId_${userId}`,
                ];
                keysToRemove.forEach(k => {
                    try { localStorage.removeItem(k); } catch (e) {}
                });

                // Remove any keys that include the userId (defensive)
                try {
                    Object.keys(localStorage).forEach(k => {
                        if (k && k.indexOf(String(userId)) !== -1) {
                            try { localStorage.removeItem(k); } catch (e) {}
                        }
                    });
                } catch (e) {
                    // ignore
                }
            }
            // Also remove some legacy/global keys that may contain personal data
            try {
                const globalKeys = ['vp_selectedPatientId', 'vp_patientListSearch', 'vp_patientMetrics', 'vp_patientScores'];
                globalKeys.forEach(k => {
                    try { localStorage.removeItem(k); } catch (e) {}
                });
            } catch (e) {}
        } catch (e) {
            // ignore errors during cleanup
        }

        // dispatch logout action — reducer will clear sessionStorage
        dispatch({ type: LOGOUT });
    }
}


